import React from 'react'

import SectionBar from '@/components/myTicket/components/myTicketSectionBar/view'
import DefaultTemplate from '@/components/purchase/components/shared/purchaseComplete/components/sharedParkinglot/components/default'
import SectionTemplate from '@/components/purchase/components/shared/purchaseComplete/components/sharedParkinglot/components/section'
import UnitTemplate from '@/components/purchase/components/shared/purchaseComplete/components/sharedParkinglot/components/unit'

import type { ShareAbleTime } from '@/api/client/purchase/dto/purchaseDto'
import type { SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import Button from '@/shared/components/button/Button'
import Cover from '@/shared/components/Cover'
import NaverPreLog from '@/shared/components/scripts/NaverPreLog'
import NaverPreLogPurchase from '@/shared/components/scripts/NaverPreLogPurchase'
import { Text } from '@/shared/components/typography'
import { formatTime } from '@/shared/utils/date'

const SharedPurchaseComplete = ({
  isComplete,
  data,
  time,
  carNum,
  onClick
}: {
  isComplete: boolean
  data: SharedParkinglotDetail
  time: ShareAbleTime['usingTime']
  carNum: string
  onClick: () => void
}) => {
  const { basic } = data
  const { category, name, type } = basic

  const paymentSuccessInfoTemplate = () => {
    const isDefault = category === 2
    const isSection = !isDefault && type === 'SECTION'
    const isUnit = !isDefault && type === 'UNIT'

    if (isDefault) {
      return <DefaultTemplate name={name} />
    } else if (isSection) {
      return <SectionTemplate name={name} />
    } else if (isUnit) {
      return <UnitTemplate name={name} />
    }
  }

  return (
    <Cover isOpen={isComplete} className="left-0 top-0 flex h-full w-full flex-1 flex-col bg-010">
      <div className="flex w-full flex-1 flex-col justify-around px-6 pt-12">
        {paymentSuccessInfoTemplate()}
        <div className="flex flex-col gap-4">
          <SectionBar border="border-t-[1px]" borderColor="border-030" />
          <div className="flex flex-col gap-4 px-4">
            <div className="flex flex-col gap-[6px]">
              <Text level="text2" color="text090" className="ellipsis">
                {name}
              </Text>

              <div className="flex justify-between">
                <Text level="text3" color="text070">
                  주차 시간
                </Text>
                <Text level="text3" color="text070">
                  {formatTime(time)}
                </Text>
              </div>
              <div className="flex justify-between">
                <Text level="text3" color="text070">
                  차량번호
                </Text>
                <Text level="text3" color="text070">
                  {carNum}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sticky bottom-0 px-4 pb-3">
        <Button
          text="주차권 보기"
          className="body-1 h-[56px]"
          pyValue="py-0"
          color="text010"
          background="bg030"
          disabled={false}
          onClick={onClick}
        />
      </div>
      <NaverPreLog />
      <NaverPreLogPurchase />
    </Cover>
  )
}

export default SharedPurchaseComplete
